import {
  Record,
  String as RTString,
  Static,
  Number as RTNumber
} from 'runtypes';
import { DeepPartial } from 'utility-types';
import { buildService } from './decorated-service';

const ConsentService = buildService('/nasu-svc/service/advice/rdf');

const CreateAdviceArgs = Record({
  consentID: RTNumber,
  adviceCriteria: Record({
    retirementAge: RTNumber,
    amountToInvest: RTNumber,
    dateOfBirth: RTString
  }),
  recommendation: Record({
    ticker: RTString,
    cusip: RTString,
    trpcode: RTString
  })
});

export type StaticGetConsentArgs = Static<typeof CreateAdviceArgs>;

export const postConsentAdvice = (
  args: DeepPartial<StaticGetConsentArgs>
): Promise<any> => {
  const validated: StaticGetConsentArgs = CreateAdviceArgs.check(args);
  return ConsentService.add(validated);
};
